<template>
<div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
        <page-tool-bar
            :loading="loader"
            show_search
            show_building
            :search.sync="search"
            :chosen_building.sync="chosen_building"
        >
            <v-flex shrink>
                <div class="text-right">
                    <!-- <v-btn
                        :disabled="loader"
                        @click="print('front')"
                        color="primary"
                    >
                        <v-icon small left>print</v-icon>
                        In mặt trước
                    </v-btn>
                    <v-btn
                        :disabled="loader"
                        @click="print('back')"
                        color="primary"
                    >
                        <v-icon small left>print</v-icon>
                        In mặt sau
                    </v-btn> -->
                    <v-menu open-on-hover left offset-y>
                        <v-btn
                            slot="activator"
                            :disabled="export_csv.loading ||loader"
                            :loading="export_csv.loading"
                            color="primary"
                        >
                            <v-icon small left>print</v-icon>
                            IN THẺ XE
                        </v-btn>
                        <v-list>
                            <v-list-tile
                                @click="print('front')"
                            >
                                <v-list-tile-action>
                                    <v-icon small>notes</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    In mặt trước (bs)
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('back')"
                            >
                                <v-list-tile-action>
                                    <v-icon small>double_arrow</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    In mặt sau (bs)
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('front', true)"
                            >
                                <v-list-tile-action>
                                    <v-icon small>notes</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    In mặt trước (all)
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('back', true)"
                            >
                                <v-list-tile-action>
                                    <v-icon small>double_arrow</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    In mặt sau (all)
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('addition')"
                            >
                                <v-list-tile-action>
                                    <v-icon small>assignment</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    Danh sách bổ xung
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('room_id')"
                            >
                                <v-list-tile-action>
                                    <v-icon small>domain</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    Sort theo số phòng
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="print('motorbike_name')"
                            >
                                <v-list-tile-action>
                                    <v-icon small>two_wheeler</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>
                                    Sort theo số xe
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
        </page-tool-bar>
        <v-layout row wrap justify-center>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :rows-per-page-items="rowPerPage"
                        :search="search"
                        :loading="loader"
                        disable-initial-sort
                    >
                        <!-- :pagination.sync="pagination" -->

                        <!-- <template #headers="props">
                            <tr>
                                <th :class="`text-xs-${header.align} fw-bold`" v-for="header in props.headers" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template> -->
                        <template #items="props">
                            <td class="text-center">{{ props.item.building_text }}</td>
                            <td class="text-center">{{ props.item.room_id }}</td>
                            <td class="text-left">{{ props.item.customer_name }}</td>
                            <td class="text-left text-no-wrap">{{ props.item.name }}</td>
                            <td>
                                <v-checkbox
                                    :key="props.item._id"
                                    v-if="!loading_device.includes(props.item._id)"
                                    :label="props.item.printed ? 'Đã in thẻ xe' : 'Chưa in'"
                                    color="primary"
                                    v-model="props.item.printed"
                                    hide-details
                                    @change="updatePrinted(props.item)"
                                ></v-checkbox>
                                <v-progress-circular v-else color="primary" indeterminate size="24" class="ml-2"></v-progress-circular>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

	<print-portal :layout="layout[print_type]" :open="print_bike_ticket" :force_close="force_close" @close="print_bike_ticket = false">
        <bike-card :items="print_list" :type="print_type" :title="print_title" :building_text="building_text"></bike-card>
	</print-portal>
    <!-- <export-csv-button
        :trigger="export_csv.trigger"
        :title="export_csv.title"
        :rows="export_csv.rows"
    ></export-csv-button> -->
</div>
</template>

<script>
import api from '../../api'
import { buildParamQuery, formatTimeServer } from 'Helpers'
import moment from 'moment'
import { list_building } from 'Constants/db-config'
// import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'
import PrintPortal from 'Components/Print/PrintPortal'
import BikeCard from 'Components/Print/PrintTheXe'

export default {
    name:"bang-danh-sach-xe",
    components: {
        // ExportCsvButton,
        PrintPortal,
        BikeCard
    },
    data() {
        return {
            loader: false,
            search:'',
            headers: [
                { text: "Tòa nhà", align: "center", value: "building" },
                { text: "Số Phòng", align: "center", value: "room_id" },
                // { text: "Mã khách hàng", align: "center", value: "customer_id" },
                { text: "Họ và tên", align: "left", value: "customer_name" },
                { text: "Số xe", align: "left", value: "name" },
                { text: "Thẻ xe", align: "left", value: "printed"},
            ],
            list_building: [
                {text: 'Tất cả', value: ''},
                ...list_building
            ],
            list_search_type: [
                { text: 'Số phòng', value: 'roomId' },
                { text: 'Tên khách hàng', value: 'name' },
                // { text: 'Biển số xe', value: 'motorbike' }
            ],
            chosen_building: '',
            items: [],
            loading: {
                submit: false
            },
            rowPerPage: [20,50,100,{"text":"Tất cả","value":-1}],
			export_csv: {
				loading: false,
				trigger: false,
				title: "",
				rows: []
            },
            loading_device: [],
            // pagination: {
            //     sortBy: 'printed'
            // },
            print_bike_ticket: false,
            print_type: "",
            force_close: 1,
            // export_csv: {
			// 	loading: false,
			// 	trigger: false,
			// 	title: "",
			// 	rows: []
            // },
            layout: {
                front: "portrait; margin: 0.2in 0;",
                back: "portrait; margin: 0.2in 0;",
                addition: "portrait; margin: auto;",
                room_id: "portrait; margin: auto;",
                motorbike_name: "portrait; margin: auto;"
            },
            print_title: '',
            building_text: '',
            print_list: []
        };
    },
    computed: {
    },
    created(){
        this.getData()
    },
    watch: {
        chosen_building(){
            this.getData()
        }
    },
    methods: {
        getData: async function (){
            this.items = []
            this.loader = true
            const params = {
                building: this.chosen_building,
                type: "MB"
            }
            const query = buildParamQuery(params)
            let data = await api.getDevice(query)
            // let data = await api.getListCustomers()
            this.items = data.data.map(device => this.handleData(device)).sort((a,b) => {
                if (a.printed) return 1;
                else if (b.printed) return -1;
                return 0;
            })
            this.loader = false
        },
        handleData: function (item){
            const building = list_building.find(building => building.value == item.building)
            item.building_text = building.text
            item.customer_name = item.customers && item.customers[0] ? item.customers[0].name : "";
            return item
        },
        // exportCSV: function(){
		// 	const rows = this.unprint_items.map((item, index) => {
		// 		return {
		// 			"STT": index + 1,
		// 			"SỐ PHÒNG": item.room_id,
		// 			"HỌ VÀ TÊN": item.name,
		// 			"BIỂN SỐ XE": item.bike,
		// 			"GHI CHÚ": item.bike,
		// 		}
		// 	})
        //     this.export_csv.rows = rows;
        //     const date = new Date().toISOString().substring(0, 10)
		// 	this.export_csv.title = "the-xe-" +(this.chosen_building ? this.chosen_building + "-" : "")+ date;
		// 	this.export_csv.trigger = !this.export_csv.trigger;
        // },
        updatePrinted: async function (device){
            this.loading_device.push(device._id);
            const data = await api.updateReceipt(`/devices/${device._id}`, { printed: device.printed });
            const index = this.loading_device.indexOf(device._id)
			this.loading_device.splice(index, 1);
			if (data.status == 200){
            } else {
                device.printed = !device.printed
            }
        },
        async print(type, print_all){
            if (this.print_bike_ticket){
                this.force_close++
                await this.$nextTick();
            }
            const building = this.list_building.find(building => building.value == this.chosen_building);
            this.building_text = building.text.toUpperCase();

            switch(type){
                case 'front':
                case 'back':
                case 'addition':
                    this.print_title = `DANH SÁCH BỔ XUNG THẺ XE ${this.building_text !== "Tất cả" ? this.building_text : "TẤT CẢ TÒA NHÀ" }`;
                    this.print_list = this.items.filter(i => print_all || !i.printed);
                    break;
                case 'room_id':
                    this.print_title = `DANH SÁCH THẺ XE TRONG ${this.building_text !== "Tất cả" ? "TÒA NHÀ " + this.building_text : "TẤT CẢ TÒA NHÀ" } SẮP XẾP THEO SỐ PHÒNG`;
                    this.print_list = this.items.filter(i => i.printed);
                    break;
                case 'motorbike_name':
                    this.print_title = `DANH SÁCH THẺ XE TRONG ${this.building_text !== "Tất cả" ? "TÒA NHÀ " + this.building_text : "TẤT CẢ TÒA NHÀ" } SẮP XẾP THEO BIỂN SỐ XE THỨ TỰ A ĐẾN Z`;
                    this.print_list = this.items.filter(i => i.printed).sort((a,b) => a.name.localeCompare(b.name));
                    break;
                default:
                    this.print_title = '';
            }
            this.print_type = type;
            this.print_bike_ticket = true;
        }
    }
};
</script>
<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>